import { Button, Card, Col, Modal, Row } from 'antd';
import React, { useState } from 'react';
import { Navigate } from "react-router-dom";

import AddLeave from "./AddLeave";
import LeaveAllocation from './leaveAllocation';
import "./Leave.css";

const Leave = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const [leaveDrawerOpen, setLeaveDrawerOpen] = useState(false);

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<>
			<div className="flex justify-between items-center mb-4">
				<span />
				<Button
					type="primary"
					className="leave-apply-btn"
					onClick={() => setLeaveDrawerOpen(true)}
				>
					Apply for Leave
				</Button>
			</div>
			<Row gutter={16}>
				<Col span={24}>
					<Card title="Leave Allocation">
						<LeaveAllocation />
					</Card>
				</Col>
			</Row>
			<Modal
				title="Apply for Leave"
				open={leaveDrawerOpen}
				onCancel={() => setLeaveDrawerOpen(false)}
				footer={null}
				width={520}
				destroyOnClose
			>
				<AddLeave onCancel={() => setLeaveDrawerOpen(false)} />
			</Modal>
		</>
	);
};

export default Leave;
